(function() {
	"use strict"

	angular.module( "ATMGCheckout")

		.controller( "ConfirmationController", [
			"User",
			"AddressBook",
			"$window",
			"$stateParams",
			"Loader",
			"ErrorService",
			"$scope",
			"Analytics",
			"$timeout",
			"Checkout",
			"$location",
			"CartService",
			function(User, AddressBook, $window, $stateParams, Loader, ErrorService, $scope, Analytics, $timeout, Checkout, $location, CartService) {

				var _this = this;

				this.User = User.getUserData();
				this.AddressBook = AddressBook;
				// this.info = this.User.Cart.checkout;
				this.Checkout = Checkout;
				this.status = {
					loading: true
				}

				// this.CartContent = CartContent

				this.Cart = this.User.Cart

				// toggles headr behavior
				this.report = false;

				if ($stateParams.cartId) {
					this.Cart.init($stateParams.cartId)
					.then(() => {
						return Checkout.init(this.Cart)
					})
					.then(() => {
						this.status.loading = false;
						this.checkCWI()
						if (shouldSubmitAnalytics()) {
							$timeout(() => {
								submitTransaction(false); // actually send
							}, 2000);
						} else if (isEnvDev()) {
							$timeout(() => {
								submitTransaction(true); // pretend
							}, 2000);
						}
					})
				}

				function shouldSubmitAnalytics() {
					return $location.host().match(/www.atmgurus.com/) && $location.url().match(/confirmation/);
				}

				function isEnvDev() {
					return $location.host().match(/dev/) || $location.host().match(/test/);
				}

				this.checkCWI = function() {
					var orders = Checkout.Cart.getOrders()

					Object.keys(orders).forEach(function(order_id) {
						var order = orders[order_id]

						CartService.cwi_order(order_id)
							.then(function(response) {
								order.cwi_check = response.data;
							})
					});
				}

				function submitTransaction(pretend) {

					// discard if undefined or null
					if (pretend == null) return;

					var orders = Checkout.Cart.getOrders(),
						contact = Checkout.getContactDetails(),
						address = Checkout.address;

					var state_prov = address.province || address.state,
						country = address.country,
						city = address.city;

					Object.keys(orders).forEach(function(order_id) {
						var order = orders[order_id],
							lineItems = order.items;

						// console.log(
						// 		order_id,
						// 		order.order_type,
						// 		order.grand_total,
						// 		order.tax,
						// 		order.shipping,
						// 		city,
						// 		state_prov,
						// 		country
						// 	)

						//if (! pretend) {
						//	Analytics.addTrans(
						//		order_id,
						//		order.order_type,
						//		order.grand_total,
						//		order.tax,
						//		order.shipping,
						//		city,
						//		state_prov,
						//		country
						//	);
						//}


						//lineItems.forEach(function(item) {
							// console.log(
							// 	item.order_number,
							// 	item.item_primary_key,
							// 	item.item_group,
							// 	item.description,
							// 	item.selling_price,
							// 	item.quantity
							// )

						//	if (! pretend) {
						//		Analytics.addItem(
						//			item.order_number,
						//			item.item_primary_key,
						//			item.item_group,
						//			item.description,
						//			item.selling_price,
						//			item.quantity
						//		)
						//	}

						//})

						if (! pretend) {
							Analytics.trackTrans(
								order_id,
								order.order_type,
								order.grand_total,
								order.tax,
								order.shipping,
								city,
								state_prov,
								country, 
								lineItems
							);
						}

						// console.log(Analytics._logs)
					})
				}

				/**
				*	warnings
				*	if the cart chargin resulted in a warning here is where we provide its content to the view
				*/
				this.getConfirmationWarning = function() {
					return ErrorService.get("confirmation");
				}

			}
		])
})()


// WEBPACK FOOTER //
// ./src/app/modules/ATMGCheckout/controllers/ConfirmationController.js